/**
 * @generated SignedSource<<aac277e05e546bc28234731c8e8d553f>>
 * @relayHash 316af78bd05ec4dd9ecf07897bba7068
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 316af78bd05ec4dd9ecf07897bba7068

import { ConcreteRequest } from 'relay-runtime';
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type insureeDataFromSasisByNameAndDateOfBirthQuery$variables = {
  dateOfBirth: any;
  firstName: string;
  lastName: string;
};
export type insureeDataFromSasisByNameAndDateOfBirthQuery$data = {
  readonly ch_insureeDataFromSasisByNameAndDateOfBirth: {
    readonly mapped: {
      readonly address: {
        readonly city: string;
        readonly countryCode: string;
        readonly houseNumberStreet: string;
        readonly postalCode: string;
      };
      readonly dateOfBirth: any;
      readonly firstName: string;
      readonly gatekeeperZsr: string | null;
      readonly gender: Gender;
      readonly healthInsurance: string;
      readonly insuranceCardNumber: string;
      readonly insureeNumber: string;
      readonly isPrimary: boolean;
      readonly lastName: string;
      readonly nationalInsuranceNumber: number;
      readonly socialSecurityNumber: string | null;
      readonly validFrom: any;
      readonly validTo: any;
    } | null;
    readonly rawXml: string | null;
    readonly returnCode: string | null;
    readonly returnMessage: string | null;
  };
};
export type insureeDataFromSasisByNameAndDateOfBirthQuery = {
  response: insureeDataFromSasisByNameAndDateOfBirthQuery$data;
  variables: insureeDataFromSasisByNameAndDateOfBirthQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateOfBirth"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firstName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastName"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dateOfBirth",
        "variableName": "dateOfBirth"
      },
      {
        "kind": "Variable",
        "name": "firstName",
        "variableName": "firstName"
      },
      {
        "kind": "Variable",
        "name": "lastName",
        "variableName": "lastName"
      }
    ],
    "concreteType": "SasisLookupResult",
    "kind": "LinkedField",
    "name": "ch_insureeDataFromSasisByNameAndDateOfBirth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PatientInsuranceCardDetails",
        "kind": "LinkedField",
        "name": "mapped",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOfBirth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gender",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insureeNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insuranceCardNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "socialSecurityNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "healthInsurance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nationalInsuranceNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPrimary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gatekeeperZsr",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "houseNumberStreet",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rawXml",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "returnCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "returnMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "insureeDataFromSasisByNameAndDateOfBirthQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "insureeDataFromSasisByNameAndDateOfBirthQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "316af78bd05ec4dd9ecf07897bba7068",
    "metadata": {},
    "name": "insureeDataFromSasisByNameAndDateOfBirthQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fc70f9e60d901f9292ca790470ed684a";

export default node;
